import React from 'react';
import { ScrollCarousel, CarouselItem } from '@lux-sandbox/carousel';
import { getCampaignImage } from '@browsing/campaign';
import { trackSelectPromotion } from '@browsing/tracking';
import { ErrorBoundary } from '@browsing/components';

import { Campaign } from '@shared/types/mylounge';

import { CampaignCardMini } from '../campaigns/components/campaign-card-mini';
import * as S from './gre-carousel.styles';
import AllCampaignsCard from '../campaigns/components/all-campaigns-card';

interface GRECarouselProps {
    campaigns: Campaign[];
}

const GRECarousel = ({ campaigns }: GRECarouselProps) => {
    return (
        <S.GRECarouselWrapper>
            <ScrollCarousel
                aria-labelledby="gre-carousel-title"
                visibleItems={2}
                visibleItemsSm={4}
                visibleItemsLg={6}
                withOverflow
            >
                {campaigns.map((campaign, index) => {
                    const handleCampaignClick = () => {
                        trackSelectPromotion({
                            element: 'gre_carousel',
                            creativeName: 'gre_carousel',
                            item: { campaignIdentifier: campaign.campaignId },
                        });
                    };

                    if (index === campaigns.length - 1) {
                        const media = getCampaignImage(campaign, '1x2');

                        return (
                            <CarouselItem key={campaign.campaignId}>
                                <ErrorBoundary
                                    componentName={`GRECarouselAllCampaignsCard-${campaign.campaignId}`}
                                >
                                    <AllCampaignsCard imageUrl={media.url} />
                                </ErrorBoundary>
                            </CarouselItem>
                        );
                    }

                    const media = getCampaignImage(campaign, '1x1');

                    return (
                        <CarouselItem key={campaign.campaignId}>
                            <ErrorBoundary
                                componentName={`GRECarouselCampaignCard-${campaign.campaignId}`}
                            >
                                <CampaignCardMini
                                    campaign={campaign}
                                    media={media}
                                    bgTransparent
                                    hideTimeLeft
                                    onClick={handleCampaignClick}
                                />
                            </ErrorBoundary>
                        </CarouselItem>
                    );
                })}
            </ScrollCarousel>
        </S.GRECarouselWrapper>
    );
};

export default GRECarousel;
